import React, { useEffect, useRef, useState } from 'react';
import CloseIcon from '@mui/icons-material/Close';
import NtactLogo from '../assets/NTACT Logo.svg';
import { Document, Page, Text, View, StyleSheet, Image, PDFViewer } from '@react-pdf/renderer';
import { Viewer, Worker } from '@react-pdf-viewer/core';
import '@react-pdf-viewer/core/lib/styles/index.css';
import '@react-pdf-viewer/default-layout/lib/styles/index.css';
import LOgo from '../assets/Ntact.png'
import { Backdrop, CircularProgress } from '@mui/material';
import api from '../api/api';

import dayjs from 'dayjs';
import { redcheck } from '../utils/svgs/svgs';
import VehicleCheckTable from './vechilechecktablenative';
const styles = StyleSheet.create({
  page: {
        flexDirection: "column",
    paddingHorizontal: 10, // reduce this from 20–40 if needed
    paddingVertical: 10,
    // padding: 10,
    fontSize: 8,
    fontFamily: "Helvetica",
    display: "flex",
    flexDirection: "column",
    justifyContent: "flex-start",
  },

  header: {
    flexDirection: "row",
    justifyContent: "space-between",
    alignItems: "center",
    marginBottom: 4,
    borderBottom: "1px solid #ccc",
    paddingBottom: 2,
  },
  logo: { width: 45, height: 20 },
  title: { fontSize: 10, fontWeight: "bold" },

  grid: {
    flexDirection: "row",
    justifyContent: "space-between",
    marginBottom: 4,
  },
  gridItem: {
    border: "1px solid #ccc",
    padding: 2,
    width: "32%",
  },

  table: { border: "1px solid #ccc", marginBottom: 4 },
  tableRow: { flexDirection: "row", borderBottom: "1px solid #ccc" },
  tableCell: {
    borderRight: "1px solid #ccc",
    padding: 2,
    flex: 1,
    textAlign: "center",
    fontSize: 7,
  },
  tableHeader: {
    backgroundColor: "#f3f4f6",
    fontWeight: "bold",
  },

  note: {
    border: "1px solid #FECACA",
    backgroundColor: "#FEE2E2",
    padding: 3,
    marginBottom: 4,
    fontSize: 7,
  },

  comments: { border: "1px solid #ccc", padding: 4, marginVertical: 4 },

  signatureGrid: {
    flexDirection: "row",
    justifyContent: "space-between",
    marginTop: 6,
  },
  signatureItem: { border: "1px solid #ccc", padding: 3, width: "48%" },
  underline: { borderBottomWidth: 0.5, borderBottomColor: "#ccc", marginVertical: 1 },
});

const PDFDocument = ({
  imagesarray,
  allUnits,
  dates,
  driverName,
  unitNumber,
  filledDate,
    commentsData,
  allDateEntries,
  weekData,
  vehicleComponents,
  logData,
  comments,
  checkedBy,
}) => {
  const buildWeeks = (weekData) => {
  const dates = Object.keys(weekData)
    .filter(d => dayjs(d, "YYYY-MM-DD", true).isValid())
    .sort();

  if (!dates.length) return [];

  const weeks = {};

  dates.forEach(d => {
    const start = dayjs(d).startOf("week").format("YYYY-MM-DD");
    const end = dayjs(d).endOf("week").format("YYYY-MM-DD");
    const key = `${start}_${end}`;

    if (!weeks[key]) {
      const fullWeek = [];
      for (let i = 0; i < 7; i++) {
        fullWeek.push(dayjs(start).add(i, "day").format("YYYY-MM-DD"));
      }

      weeks[key] = { start, end, dates: fullWeek };
    }
  });

  return Object.values(weeks);
};

const weeklyTables = buildWeeks(weekData);
  // 🗓 Generate full week dates
  const getFullWeekDates = (weekData) => {
    const dates = Object.keys(weekData).sort();
    if (!dates.length) return [];
    const start = dayjs(dates[0]);
    const fullWeek = [];
    for (let i = 0; i < 7; i++) {
      fullWeek.push(start.add(i, "day").format("YYYY-MM-DD"));
    }
    return fullWeek;
  };

  const fullWeekDates = getFullWeekDates(weekData);

  return (
    <Document>
{/* <Page size={{ width: 1000, height: 595 }} style={styles.page} > */}
<Page size={{ width: 1000, height: 1400 }} style={styles.page} wrap={false}>

        {/* Header */}
        <View style={styles.header}>
          <Image src={LOgo} style={styles.logo} />
          <Text style={styles.title}>WEEKLY DRIVER LOG & SAFETY</Text>
          <View style={{ width: 50 }} />
        </View>

        {/* Driver Info */}
        <View style={styles.grid}>
          <View style={styles.gridItem}>
            <Text style={{ fontWeight: "bold" }}>Driver:</Text>
            <Text>{driverName}</Text>
            <View style={styles.underline} />
          </View>
          {/* <View style={styles.gridItem}>
            <Text style={{ fontWeight: "bold" }}>Unit #:</Text>
            <Text>{unitNumber}</Text>
            <View style={styles.underline} />
          </View> */}
          <View style={styles.gridItem}>
            <Text style={{ fontWeight: "bold" }}>Date:</Text>
            <Text>{dates || filledDate}</Text>
            <View style={styles.underline} />
          </View>
            <View style={styles.gridItem}>
            {/* <Text style={{ fontWeight: "bold" }}>Unit #:</Text>
            <Text>{unitNumber}</Text>
            <View style={styles.underline} /> */}
          </View>
        </View>
<View style={{ borderWidth: 1, borderColor: "#000", marginBottom: 6 }}>

  {allUnits?.map((item, i) => (
    <View key={i} style={{ flexDirection: "row", borderBottomWidth: 1, borderColor: "#000" }}>

      {/* DATE */}
      <View style={{ width: "25%", padding: 4, borderRightWidth: 1, borderColor: "#000" }}>
        <Text style={{ fontSize: 9, fontWeight: "bold" }}>Date</Text>
        <Text style={{ fontSize: 9 }}>{item.date}</Text>
      </View>

      {/* FUEL */}
      <View style={{ width: "35%", padding: 4, borderRightWidth: 1, borderColor: "#000" }}>
        <Text style={{ fontSize: 9, fontWeight: "bold" }}>Fuel Allocation</Text>
        <Text style={{ fontSize: 9 }}>{item.fuel}</Text>
      </View>

      {/* UNIT */}
      <View style={{ width: "40%", padding: 4 }}>
        <Text style={{ fontSize: 9, fontWeight: "bold" }}>
          {item.fuel?.toLowerCase() === "equipment"
            ? "Equipment Description"
            : "Unit #"}
        </Text>
        <Text style={{ fontSize: 9 }}>{item.unit}</Text>
      </View>

    </View>
  ))}

</View>

        {/* Log Table */}
        <View style={styles.table}>
          <View style={[styles.tableRow, styles.tableHeader]}>
            <Text style={styles.tableCell}>Date</Text>
            <Text style={styles.tableCell}>Mileage Start</Text>
            <Text style={styles.tableCell}>Mileage End</Text>
            <Text style={styles.tableCell}>Job #</Text>
            <Text style={styles.tableCell}>Repair/Fill-up Location</Text>
            <Text style={styles.tableCell}>Gallons Fuel</Text>
            <Text style={styles.tableCell}>Total Amount</Text>
            <Text style={styles.tableCell}>Mileage @ Repair/Fill-up</Text>
          </View>

          {logData.length > 0 ? (
            logData.map((log, index) => (
              <View key={index} style={styles.tableRow}>
                <Text style={styles.tableCell}>{log.date}</Text>
                <Text style={styles.tableCell}>{log.mileage_start}</Text>
                <Text style={styles.tableCell}>{log.mileage_end}</Text>
                <Text style={styles.tableCell}>{log.job_number}</Text>
                <Text style={styles.tableCell}>{log.repair_fillup_location}</Text>
                <Text style={styles.tableCell}>{log.gallons_fuel}</Text>
                <Text style={styles.tableCell}>{log.total_amount}</Text>
                <Text style={styles.tableCell}>{log.mileage_at_repair_fillup}</Text>
              </View>
            ))
          ) : (
            <View style={styles.tableRow}>
              <Text style={[styles.tableCell, { flex: 8 }]}>No log data available</Text>
            </View>
          )}
        </View>

        {/* Note Section */}
        <View style={styles.note} break={false}>
          <Text>
            NOTE: Seat belts shall be worn any time the vehicle is in motion. This log shall be kept current and turned in weekly.
          </Text>
        </View>

        {/* Vehicle Safety Check */}
        <Text
          style={{
            marginVertical: 4,
            fontWeight: "bold",
            fontSize: 9,
          }}
        >
          Vehicle Safety Check
        </Text>
        <Text style={{ fontSize: 8, marginBottom: 3 }}>
          Check YES for good condition, NO if item requires attention (add comment)
        </Text>

        {/* Vehicle Table */}
   {weeklyTables.map((week, wIndex) => (
  <View key={wIndex} style={{ marginBottom: 8 }}>

    <Text style={{ fontSize: 9, fontWeight: "bold", marginBottom: 3 }}>
      Week: {dayjs(week.start).format("MMM DD")} - {dayjs(week.end).format("MMM DD")}
    </Text>

    <VehicleCheckTable
      fullWeekDates={week.dates}
      allDateEntries={allDateEntries}
      weekData={weekData}
      vehicleComponents={vehicleComponents}
    />
  </View>
))}

        {/* Comments */}
       {commentsData?.length > 0 && (
  <View style={styles.comments}>
    <Text style={{ fontWeight: "bold", marginBottom: 4 }}>
      COMMENTS (NOTE ANY ITEMS OR REPAIRS NEEDED)
    </Text>

    {commentsData.map((c, i) => (
      <View key={i} style={{ marginBottom: 4 }}>
        <Text style={{ fontSize: 8, color: "#555" }}>
          {dayjs(c.date).format("MMM DD, YYYY")}
        </Text>

        <Text style={{ fontSize: 8 }}>{c.comment}</Text>
      </View>
    ))}
  </View>
)}
{/* Comment Images by Date */}
{imagesarray?.commentImagesByDate &&
  Object.keys(imagesarray.commentImagesByDate).length > 0 && (
    <View style={{ marginTop: 10 }}>
      <Text style={{ fontWeight: "bold", marginBottom: 4, fontSize: 9 }}>
        COMMENT IMAGES (BY DATE)
      </Text>

      {Object.entries(imagesarray.commentImagesByDate).map(([date, imgs], idx) => (
        <View key={idx} style={{ marginBottom: 10 }}>
          <Text
            style={{
              fontSize: 8.5,
              fontWeight: "bold",
              marginBottom: 3,
            }}
          >
            {dayjs(date).format("MMM DD, YYYY")}
          </Text>

          <Text
            style={{
              fontSize: 8,
              marginBottom: 3,
              textDecoration: "underline",
            }}
          >
            Comment Images:
          </Text>

          <View
            style={{
              flexDirection: "row",
              flexWrap: "wrap",
              gap: 5,
              marginBottom: 6,
            }}
          >
            {imgs.map((img, i) => (
              <View
                key={i}
                style={{
                  width:80,
                  height: 40,
                  borderWidth: 1,
                  borderColor: "#D1D5DB",
                  borderRadius: 3,
                  marginRight: 5,
                  marginBottom: 5,
                  alignItems: "center",
                  justifyContent: "center",
                }}
              >
                {img?.base64_data && (
                  <Image
                    src={img.base64_data}
                    style={{
                      width: 80,
                      height: 40,
                      objectFit: "contain",
                    }}
                  />
                )}
              </View>
            ))}
          </View>
        </View>
      ))}
    </View>
  )}

        {/* Signatures */}
        {/* Signatures */}
<View style={styles.signatureGrid}>
  <View style={styles.signatureItem}>
    <Text style={{ fontWeight: "bold" }}>Checked By:</Text>
    <Text>{checkedBy}</Text>
    <View style={styles.underline} />
  </View>

  <View style={styles.signatureItem}>
    <Text style={{ fontWeight: "bold" }}>Driver Signature:</Text>
    {imagesarray?.driverSignature?.base64_data && (
      <Image
        src={imagesarray.driverSignature.base64_data}
        style={{
         width: 80,   // reduced from 120 → 80
      height: 40,
          objectFit: "contain",
          borderWidth: 1,
          borderColor: "#D1D5DB",
          borderRadius: 2,
          marginTop: 3,
        }}
      />
    )}
    <View style={styles.underline} />
  </View>
</View>

       
      </Page>
    </Document>
  );
};

 {/* <View style={styles.signatureGrid}>
          <View style={styles.signatureItem}>
            <Text style={{ fontWeight: "bold" }}>Checked By:</Text>
            <Text>{checkedBy}</Text>
            <View style={styles.underline} />
          </View>
          <View style={styles.signatureItem}>
            <Text style={{ fontWeight: "bold" }}>Driver Signature:</Text>
            {imagesarray?.[0]?.base64_data && (
              <Image
                source={{ uri: imagesarray[0].base64_data }}
                style={{
                  width: 120,
                  height: 60,
                  resizeMode: "contain",
                  borderWidth: 1,
                  borderColor: "#D1D5DB",
                  borderRadius: 2,
                  marginTop: 3,
                }}
              />
            )}
            <View style={styles.underline} />
          </View>
        </View> */}
const WDSMergeFormModal = ({ setFormView, rowData }) => {
     const [loader,setLoader]=useState(false)
  const formRef = useRef(null);
 console.log(rowData,'roww')
  const [pdfBlob, setPdfBlob] = useState(null);
    const [imagesarray,setImagesArray]=useState([])
    const weekreport=rowData.json_data

    // Preprocess weekreport into a structure: { date: { component: "Y/N" } }
  const weekData = {};

weekreport.forEach((report) => {
const date = dayjs(report.filled_date).isValid()
  ? dayjs(report.filled_date).format("YYYY-MM-DD")
  : null;

if (!date) return; // skip invalid

  const compMap = {};
  (report.json_data || []).forEach((q) => {
    if (q?.question && q.question.includes("Vehicle Safety Check")) {
      const component = q.question.split(" - ").pop().trim();
      const answer = q.answer?.toUpperCase().startsWith("Y") ? "Y" : "N";
      compMap[component] = answer;
    }
  });

  if (!weekData[date]) weekData[date] = [];
  weekData[date].push(compMap);
});


  // Step 2: Ordered list of vehicle components
  const vehicleComponents = [
    "ACCIDENT FORM", "BATTERY", "BELTS", "BRAKE FLUID", "ENGINE OIL",
    "FIRE EXTINGUISHER (10lb)", "FIRST AID KIT", "HEADLAMPS & HI-BEAMS",
    "HEATER HOSES", "HITCH, RECEIVER, AND PINS", "HORN", "INSURANCE CARD",
    "JACK & TIRE IRON", "LIGHTS (Parking & BRAKE)", "MIRRORS", "PARKING BRAKE",
    "RADIATOR FLUID", "RADIATOR HOSES", "SEATBELTS", "SPARE TIRE",
    "STEERING FLUID", "TIRE PSI", "TRANSMISSION OIL", "TURN SIGNALS",
    "WASHER FLUID", "WINDSHIELD WIPERS"
  ];

  // Step 3: Flatten dates with indexes → [ {date, idx, data} ]
const allDateEntries = [];
Object.keys(weekData)
  .sort()
  .forEach((date) => {
    const entries = weekData[date]?.filter(d => d && Object.keys(d).length > 0);
    if (entries && entries.length > 0) {
      entries.forEach((data, idx) => {
        allDateEntries.push({ date, idx, data });
      });
    }
  });


    console.log(allDateEntries,'dates')
  // Extract relevant data from rowData
  const driverName = rowData?.emp_name || 'N/A';
  const unitNumber =
     rowData?.json_data[0]?.json_data?.find((item) => item.question === 'Driver Information - Unit Number')?.answer || 'N/A';
  const filledDate = rowData?.filled_date || 'N/A';
const formsData =
  rowData?.json_data
    ?.filter(item => item.form_type === "WDS")   // only real forms
    ?.sort((a, b) => new Date(a.filled_date) - new Date(b.filled_date))
    ?.map(form => {
      const unitNumber =
        form?.json_data?.find(
          q => q.question === "Driver Information - Unit Number"
        )?.answer || "N/A";

      const fuelAllocation =
        form?.json_data?.find(
          q => q.question === "Driver Information - Fuel Allocation"
        )?.answer || "N/A";

      const filledDate = form?.filled_date || "N/A";

      return { unitNumber, fuelAllocation, filledDate };
    }) || [];

  // ✅ Build logData from ALL rows, not just index 0
const logData =
  rowData?.json_data
    ?.flatMap((entry) => {
      const filledDate = entry.filled_date || "N/A";
      const driverLogs = entry?.json_data?.find(
        (item) => item.question === "Driver Log Entries"
      )?.answer;

      if (!driverLogs || !Array.isArray(driverLogs)) return [];

      return driverLogs.map((log) => ({
        date: filledDate, // <-- always use parent filled_date
        mileage_start: log.Start || "N/A",
        mileage_end: log.End || "N/A",
        job_number: log.Job || "N/A",
        repair_fillup_location: log.location || "N/A",
        gallons_fuel: log.gallons || "N/A",
        total_amount: log.amount || "N/A",
        mileage_at_repair_fillup: log.mileage || "N/A",
      }));
    }) || [];


  // Extract safety checks
  const safetyChecks = {};
  rowData?.json_data[0]?.json_data
    ?.filter((item) => item.question.includes('Vehicle Safety Check'))
    ?.forEach((item) => {
      const checkName = item.question
        .replace(' Vehicle Safety Check (Part-1) - ', '')
        .replace(' Vehicle Safety Check (Part-2) - ', '')
        .trim();
      safetyChecks[checkName] = item.answer;
    });
const fetchImages = async () => {
  try {
    console.log("%c🟢 Starting fetchImages...", "color: green; font-weight: bold;");
    setLoader(true);

    const allImagesByDate = {};
    let signatureFetched = false;
    let driverSignatureImage = null;

    console.log("📦 weekreport count:", weekreport?.length || 0);

    for (const [rIndex, report] of weekreport.entries()) {
      const reportDate = report.filled_date;
      console.log(`\n📅 Processing report [${rIndex}] - filled_date: ${reportDate}`);

      if (!Array.isArray(report.json_data)) {
        console.warn(`⚠️ report[${rIndex}] has no valid json_data`);
        continue;
      }

      // 🧠 Detect if nested
      const hasNested = report.json_data.some(item => Array.isArray(item?.json_data));
      console.log(`🔎 report[${rIndex}] hasNested:`, hasNested);

      // 🧱 Flatten if nested
      const allForms = hasNested
        ? report.json_data.flatMap(item => (Array.isArray(item.json_data) ? item.json_data : []))
        : report.json_data;

      console.log(`📄 Normalized forms count for report[${rIndex}]:`, allForms.length);

      const date =
        hasNested && report.json_data.find(i => i.filled_date)?.filled_date
          ? report.json_data.find(i => i.filled_date).filled_date
          : reportDate || "Unknown Date";

      console.log(`🗓️ Using date: ${date}`);

      // 🧩 Extract signature & comment images
      const driverSig = allForms.find(q => q.question === "Signature")?.answer || [];
      const commentImgs =
        allForms.find(q => q.question === "Comments - Uploaded Images"||q.question==='Upload Images')?.answer || [];

      console.log(`✍️ Signature found:`, driverSig);
      console.log(`💬 Comment images found:`, commentImgs);

      const filenames = [];

      // Signature (only once globally)
      if (!signatureFetched && driverSig?.[0]?.file_name) {
        filenames.push(driverSig[0].file_name);
        console.log(`✅ Added driver signature filename: ${driverSig[0].file_name}`);
        signatureFetched = true;
      }

      // Comment images
      if (Array.isArray(commentImgs)) {
        commentImgs.forEach(img => {
          if (img?.file_name) {
            filenames.push(img.file_name);
            console.log(`✅ Added comment image filename: ${img.file_name}`);
          }
        });
      }

      if (filenames.length === 0) {
        console.log(`⚠️ No filenames found for date ${date}`);
        continue;
      }

      console.log(`📤 Fetching ${filenames.length} image(s) for date ${date}...`, filenames);

      const queryParams = filenames.map(n => `filenames=${encodeURIComponent(n)}`).join("&");
      const response = await api.get(`/v1/documents/view-multiple?${queryParams}`);
      const apiImages = response?.images || [];

      console.log(`📥 API Response for ${date}:`, response);
      console.log(`🧩 Extracted ${apiImages.length} image(s)`);

      if (response.status === 200 && Array.isArray(apiImages)) {
        const ordered = filenames.map(name =>
          apiImages.find(img => img.filename === name) || null
        );

        console.log(`🧮 Ordered images:`, ordered);

        // Store signature globally
        if (!driverSignatureImage && driverSig?.[0]?.file_name) {
          driverSignatureImage = ordered.find(
            img => img?.filename === driverSig[0].file_name
          );
          console.log("✍️ Stored driver signature globally.");
        }

        // Filter only comment images
        const commentImageArray = Array.isArray(commentImgs)
          ? ordered.filter(img =>
              commentImgs.some(ci => ci.file_name === img?.filename)
            )
          : [];

        console.log(
          `💬 Found ${commentImageArray.length} comment image(s) for ${date}:`,
          commentImageArray.map(i => i?.filename)
        );

        if (!allImagesByDate[date]) allImagesByDate[date] = [];
        allImagesByDate[date].push(...commentImageArray);
      }
    }

    setImagesArray({
      driverSignature: driverSignatureImage,
      commentImagesByDate: allImagesByDate,
    });

    console.log("%c✅ Final fetched data:", "color: lime; font-weight: bold;");
    console.log("Driver Signature:", driverSignatureImage);
    console.table(
      Object.entries(allImagesByDate).flatMap(([d, imgs]) =>
        imgs.map(i => ({ Date: d, Filename: i?.filename }))
      )
    );
  } catch (error) {
    console.error("❌ Error fetching images:", error);
    setImagesArray({ driverSignature: null, commentImagesByDate: {} });
  } finally {
    setLoader(false);
    console.log("%c🔵 fetchImages completed.", "color: blue; font-weight: bold;");
  }
};



useEffect(() => {

    fetchImages();

}, []);
  // Extract comments
  const comments =   rowData?.json_data[0]?.json_data.find((item) => item.question === 'Comments')?.answer || 'No comments provided.';
const commentsData =
  rowData?.json_data?.flatMap((entry) => {
    const date = entry.filled_date;

    const comment =
      entry?.json_data?.find(
        (item) => item.question === "Comments"
      )?.answer;

    // ❌ Skip if no real value
    if (!comment || !comment.trim()) return [];

    return [{
      date,
      comment: comment.trim()
    }];
  }) || [];
  // Extract checked by and signature
  const checkedBy =   rowData?.json_data[0]?.json_data?.find((item) => item.question === 'Checked By')?.answer || 'N/A';
  const driverSignature =   rowData?.json_data[0]?.json_data?.find((item) => item.question === 'Signature')?.answer || 'N/A';
console.log(driverSignature)

  const generatePDF = async () => {
    try {
            const allUnits =
  rowData?.json_data
    ?.filter(f => f.form_type === "WDS")
    ?.map(form => {
      const unit =
        form?.json_data?.find(
          q => q.question === "Driver Information - Unit Number"
        )?.answer || "N/A";

      const fuel =
        form?.json_data?.find(
          q => q.question === "Driver Information - Fuel Allocation"
        )?.answer || "N/A";

      const date = form?.filled_date || "N/A";

      return { unit, fuel, date };
    }) || [];
      const blob = await import('@react-pdf/renderer').then(({ pdf }) =>
        pdf(
          <PDFDocument
            imagesarray={imagesarray}
            driverName={driverName}
            unitNumber={unitNumber}
            filledDate={filledDate}
            logData={logData}
              commentsData={commentsData}
            safetyChecks={safetyChecks}
            comments={comments}
            checkedBy={checkedBy}
            driverSignature={driverSignature}
            weekData={weekData}
            vehicleComponents={vehicleComponents}
allDateEntries={allDateEntries}
dates={rowData.json_data?.find(obj => obj.Dates)?.Dates ||filledDate}
allUnits={allUnits}
          />
        ).toBlob()
      );
      setPdfBlob(blob);
      const pdfUrl = URL.createObjectURL(blob);
      window.open(pdfUrl, '_blank');
    } catch (error) {
      console.error('Error generating PDF:', error);
    }
  };

  

  useEffect(() => {
    if (formRef.current) {
      formRef.current.scrollTop = 0;
    }
  }, []);
const groupDatesByWeek = (weekData) => {
  const sortedDates = Object.keys(weekData).sort();
  const weeks = {};

  sortedDates.forEach(date => {
    const weekStart = dayjs(date).startOf("week").format("YYYY-MM-DD");
    const weekEnd = dayjs(date).endOf("week").format("YYYY-MM-DD");

    const key = `${weekStart}_${weekEnd}`;

    if (!weeks[key]) {
      weeks[key] = {
        start: weekStart,
        end: weekEnd,
        dates: []
      };
    }

    weeks[key].dates.push(date);
  });

  return Object.values(weeks);
};
const buildWeeks = (weekData) => {
  const dates = Object.keys(weekData)
    .filter(d => dayjs(d, "YYYY-MM-DD", true).isValid()) // ✅ remove bad dates
    .sort();

  if (!dates.length) return [];

  const weeks = {};

  dates.forEach(d => {
    const start = dayjs(d).startOf("week").format("YYYY-MM-DD");
    const end = dayjs(d).endOf("week").format("YYYY-MM-DD");
    const key = `${start}_${end}`;

    if (!weeks[key]) {
      const fullWeek = [];
      for (let i = 0; i < 7; i++) {
        fullWeek.push(dayjs(start).add(i, "day").format("YYYY-MM-DD"));
      }

      weeks[key] = {
        start,
        end,
        dates: fullWeek
      };
    }
  });

  return Object.values(weeks);
};

const weeklyTables = buildWeeks(weekData);
const weeklyGroups = groupDatesByWeek(weekData);


  const handleBackdropClick = (e) => {
    // Check if the click target is the backdrop itself (not the modal content)
    if (e.target === e.currentTarget) {
      setFormView(false);
    }
  };
  return (
    <div  onClick={handleBackdropClick} className="fixed inset-0 z-50 flex items-center justify-center bg-black bg-opacity-40 ">
      <div className="relative w-full max-w-4xl  flex flex-col justify-center items-center p-6 bg-white rounded-lg border border-gray-300 shadow-md overflow-y-auto custom-scrollbar max-h-[95vh]">
        <div className="w-full flex justify-between items-end">
          <button
            onClick={generatePDF}
            className="bg-red-800 text-white px-4 py-1 rounded hover:bg-green-600"
          >
            Print
          </button>
          <button
            onClick={() => setFormView(false)}
            className="text-gray-600 hover:text-black"
          >
            <CloseIcon />
          </button>
        </div>

        <div ref={formRef} className="w-[90%] mt-4 mx-auto overflow-y-auto custom-scrollbar p-4">
          {/* Form Header */}
          <div className="border-b border-gray-700 pb-2 mb-4">
            <div className="flex w-full justify-between">
              <img src={NtactLogo} alt="NTACT Logo" />
              <div>
                <h2 className="text-lg font-semibold">WEEKLY DRIVER LOG & SAFETY</h2>
              </div>
              <div className="mr-24"></div>
            </div>
          </div>

          {/* Driver Info */}
          <div className="grid grid-cols-3 gap-4 mb-4">
            <div className="border border-[#9CA3AF] p-1">
              <p className="text-sm font-inter font-semibold text-left">Driver:</p>
              <p className="text-left font-inter p-1 px-2">{driverName}</p>
              <hr className="border-t border-[#9CA3AF]" />
            </div>
            <div className="border border-[#9CA3AF] p-1">
              <p className="text-sm font-inter font-semibold text-left">Unit #:</p>
              <p className="text-left font-inter p-1 px-2">{unitNumber}</p>
              <hr className="border-t border-[#9CA3AF]" />
            </div>
            <div className="border border-[#9CA3AF] p-1">
              <p className="text-sm font-inter font-semibold text-left">Date:</p>
              <p className="text-left font-inter p-1 px-2">{rowData.json_data?.find(obj => obj.Dates)?.Dates ||filledDate}</p>
              <hr className="border-t border-[#9CA3AF]" />
            </div>
          </div>
<div>
  {formsData.map((item, index) => (
    <div key={index} className="border text-start border-[#9CA3AF] p-2 mb-4">

      <p className="text-xs text-gray-500">
        Date: {item.filledDate}
      </p>

      <p className="text-sm font-semibold">
        Fuel Allocation:
      </p>
      <p className="p-1 px-2 capitalize">
        {item.fuelAllocation}
      </p>

      <hr className="border-t border-[#9CA3AF] my-1" />

      <p className="text-sm font-semibold">
        {item.fuelAllocation?.toLowerCase() === "equipment"
          ? "Equipment Description:"
          : "Unit #:"}
      </p>

      <p className="text-xs p-1 px-2">
        {item.unitNumber}
      </p>
    </div>
  ))}
</div>

          {/* Log Table */}
          <div className="mb-4">
            <div className="overflow-x-auto">
              <table className="w-full border-collapse border border-gray-300">
                <thead>
                  <tr className="bg-gray-200">
                    <th className="border border-gray-300 p-2 text-sm font-inter font-semibold">Date</th>
                    <th className="border border-gray-300 p-2 text-sm font-inter font-semibold">Mileage Start</th>
                    <th className="border border-gray-300 p-2 text-sm font-inter font-semibold">Mileage End</th>
                    <th className="border border-gray-300 p-2 text-sm font-inter font-semibold">Job #</th>
                    <th className="border border-gray-300 p-2 text-sm font-inter font-semibold">Repair/Fill-up Location</th>
                    <th className="border border-gray-300 p-2 text-sm font-inter font-semibold">Gallons Fuel</th>
                    <th className="border border-gray-300 p-2 text-sm font-inter font-semibold">Total Amount</th>
                    <th className="border border-gray-300 p-2 text-sm font-inter font-semibold">Mileage @ Repair/Fill-up</th>
                  </tr>
                </thead>
                <tbody>
                  {logData.length > 0 ? (
                    logData.map((log, index) => (
                      <tr key={index}>
                        <td className="border border-gray-300 p-2 text-sm font-inter text-center">{log.date}</td>
                        <td className="border border-gray-300 p-2 text-sm font-inter text-center">{log.mileage_start}</td>
                        <td className="border border-gray-300 p-2 text-sm font-inter text-center">{log.mileage_end}</td>
                        <td className="border border-gray-300 p-2 text-sm font-inter text-center">{log.job_number}</td>
                        <td className="border border-gray-300 p-2 text-sm font-inter text-center">{log.repair_fillup_location}</td>
                        <td className="border border-gray-300 p-2 text-sm font-inter text-center">{log.gallons_fuel}</td>
                        <td className="border border-gray-300 p-2 text-sm font-inter text-center">{log.total_amount}</td>
                        <td className="border border-gray-300 p-2 text-sm font-inter text-center">{log.mileage_at_repair_fillup}</td>
                      </tr>
                    ))
                  ) : (
                    <tr>
                      <td colSpan="8" className="border border-gray-300 p-2 text-sm font-inter text-center">No log data available</td>
                    </tr>
                  )}
                </tbody>
              </table>
            </div>
          </div>

          {/* Note Section */}
        <div className="mb-4 p-4 rounded border-t border-b"
     style={{
       borderTop: "1px solid #FECACA",
       borderBottom: "1px solid #FECACA",
       background: "#FEF2F2",
     }}
>
 
  <p className="text-sm font-inter text-left" style={{ color: "#DC2626" }}>
     NOTE: Seat belts shall be worn any time the vehicle is in motion. This log shall be kept current and turned in weekly.
  </p>
</div>
<div className="flex items-center font-semibold gap-2 my-1">
  {redcheck}
  <span>Vehicle Safety Check</span>
</div>
<div className='my-1 text-start'>Check YES for good condition, NO if item requires attention (add comment)</div>

          {/* Safety Checklist */}
       <div className="mb-4">
  <div className="w-full">
  {weeklyTables.map((week, wIndex) => {
  const fullWeekDates = week.dates;

  return (
    <div key={wIndex} className="mb-10">

      {/* week title */}
      <div className="font-semibold text-left mb-2">
        Week: {dayjs(week.start).format("MMM DD")} -{" "}
        {dayjs(week.end).format("MMM DD, YYYY")}
      </div>

      {/* 🔴 YOUR SAME TABLE */}
      <table className="min-w-full table-fixed border">
        <thead>
          <tr className="bg-gray-100">
            <th className="px-4 py-2 text-left w-1/6">
              Vehicle Component
            </th>

            {fullWeekDates.map((date) => (
              <th key={date} className="px-2 py-2 text-center w-1/12">
                {dayjs(date).format("ddd MM/DD")}
              </th>
            ))}
          </tr>
        </thead>

        <tbody>
          {vehicleComponents.map((comp) => (
            <tr key={comp} className="border-t">
              <td className="px-4 py-2 font-medium w-1/6">
                {comp}
              </td>

              {fullWeekDates.map((date) => {
                const entryForDate =
                  weekData[date]?.reduce(
                    (acc, obj) => ({ ...acc, ...obj }),
                    {}
                  ) || {};

                const val = entryForDate[comp] || "";

                return (
                  <td
                    key={date + "-" + comp}
                    className={`px-2 py-2 text-center font-bold w-1/12 ${
                      val === "Y"
                        ? "bg-green-50 text-green-600"
                        : val === "N"
                        ? "bg-red-50 text-red-600"
                        : "text-gray-400"
                    }`}
                  >
                    {val}
                  </td>
                );
              })}
            </tr>
          ))}
        </tbody>
      </table>
    </div>
  );
})}
  </div>
</div>


          {/* Comments Section */}
        <div className="mb-4">
  <div className="text-[16px] my-4 text-left font-semibold">
    COMMENTS (NOTE ANY ITEMS OR REPAIRS NEEDED)
  </div>

  {commentsData.length > 0 ? (
    commentsData.map((item, index) => (
      <div key={index} className="border text-start border-[#9CA3AF] p-2 mb-3">
        <div className="text-xs text-gray-500 mb-1">
          {dayjs(item.date).format("MMM DD, YYYY")}
        </div>

        <p className="text-sm text-gray-700">
          {item.comment}
        </p>
      </div>
    ))
  ) : (
    <div className="border border-[#9CA3AF] p-2 text-sm text-gray-500">
      No comments provided.
    </div>
  )}
</div>
{/* Comment Images by Date */}
{Object.keys(imagesarray.commentImagesByDate || {}).length > 0 && (
  <div className="mb-4">
    <div className="text-[16px] my-4 text-left font-semibold">
      COMMENT IMAGES (BY DATE)
    </div>

    {Object.entries(imagesarray.commentImagesByDate).map(([date, imgs]) => (
      <div key={date} className="mb-6">
        <p className="font-semibold mb-2 text-left">
          {dayjs(date).format("MMM DD, YYYY")}
        </p>

        <div>
          <p className="text-sm font-semibold mb-2 text-start">Comment Images:</p>
          <div className="flex flex-wrap gap-4">
            {imgs.map((img, i) => (
              <div
                key={i}
                className="w-44 h-32 flex items-center justify-center border border-gray-300 rounded-lg shadow-md bg-white hover:shadow-lg transition-shadow"
              >
                <img
                  src={img.base64_data}
                  alt={`Comment Image ${i + 1}`}
                  className="w-40 h-24 object-contain"
                />
              </div>
            ))}
          </div>
        </div>
      </div>
    ))}
  </div>
)}

       {/* Signatures */}
<div className="grid grid-cols-2 gap-4">
  <div className="border border-[#9CA3AF] p-1">
    <p className="text-sm font-inter font-semibold text-left">Checked By:</p>
    <p className="text-left font-inter p-1 px-2">{checkedBy}</p>
    <hr className="border-t border-[#9CA3AF]" />
  </div>

  <div className="border border-[#9CA3AF] p-1">
    <p className="text-sm font-inter font-semibold text-left">Driver Signature:</p>

    {imagesarray?.driverSignature?.base64_data && (
      <img
        src={imagesarray.driverSignature.base64_data}
        alt="Driver Signature"
        className="w-40 h-24 object-contain border border-gray-300 rounded-md shadow-sm bg-white mt-2"
      />
    )}

    <hr className="border-t border-[#9CA3AF]" />
  </div>
</div>

        </div>
      </div>
      <Backdrop
                    sx={{ color: "#fff", zIndex: (theme) => theme.zIndex.drawer + 1 }}
                    open={loader}
                  >
                    <CircularProgress color="inherit" />
                  </Backdrop>
    </div>
  );
};

export default WDSMergeFormModal;